import { RichText } from '@cox/core-ui8/dist/RichText'
import { useUdoContext } from '@cox/core-ui8/dist/UdoContext'

import { ReactTextProps } from './types'
import withAEM from '../../hoc/withAEM'
import { getTokenValues } from '../../utils/rule-builder-util'

const ReactText = (props: ReactTextProps): JSX.Element => {
  const { udo } = useUdoContext()
  const { text = '', isParsed = false, tokenProperties = '' } = props

  const RichTextWithAEM = withAEM(RichText)
  const value = isParsed ? text : getTokenValues(text, tokenProperties, udo?.localeName)
  //pass isParsed as true as it has been handed above, that way text will be treated as is.
  const modifiedProps = { ...props, localeName: udo?.localeName, text: value, isParsed: true }
  return <RichTextWithAEM {...modifiedProps} compName={'RichText'} data-rte-editelement={true} atomSpacing={true} />
}
export default ReactText
